import React from "react"

export const PrivateAuftraggeber = (props) => {
  return (
    <svg
      width={74}
      height={78}
      viewBox="0 0 74 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="#B3CBD4"
        stroke="#B3CBD4"
        strokeWidth={3}
        d="M16 33h15v30H16zM46 33h15v30H46z"
      />
      <path
        fill="#E5EDF0"
        stroke="#034055"
        strokeWidth={3}
        d="M10 33h15v30H10zM52 33h15v30H52z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 34h67v-7.571L38.5 9 5 26.429V34z"
        fill="#FFD62E"
        stroke="#FFD62E"
        strokeWidth={3}
      />
      <path
        clipRule="evenodd"
        d="M5 27h67v-7.571L38.5 2 5 19.429V27zM6.816 63h62.368L72 76H3l3.816-13z"
        stroke="#034055"
        strokeWidth={3}
      />
    </svg>
  )
}
